import { create } from "zustand";
import { persist } from "zustand/middleware";

interface OrderIdStore {
  orderId: string | null;
  setOrderId: (id: string) => void;
  clearOrderId: () => void;
}

const useOrderIdStore = create<OrderIdStore>()(
  persist(
    (set) => ({
      orderId: null,
      setOrderId: (id) => set({ orderId: id }),
      clearOrderId: () => set({ orderId: null }),
    }),
    {
      name: "order-id-storage", 
    }
  )
);

export default useOrderIdStore;